import React from 'react';
import Navbar from '../components/Navbar';
import BottomNav from '../components/BottomNav';

export default function Contact() {
  return (
    <div className="app-shell">
      <Navbar showBack title="Contact Us" />
      <div className="page-body" style={{ paddingBottom: 80 }}>
        <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 16, color: 'var(--navy)' }}>Contact Us</h1>

        <p style={{ fontSize: 14, lineHeight: 1.8, color: '#444', marginBottom: 24 }}>
          We're here to help. Reach out to us for any queries about your order, products, or returns.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div style={{ background: 'var(--white)', borderRadius: 10, padding: 16, border: '0.5px solid var(--card-border)' }}>
            <div style={{ fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--blue)', marginBottom: 8, fontWeight: 500 }}>Email</div>
            <a href="mailto:nobrandstore3@gmail.com" style={{ fontSize: 14, color: 'var(--navy)', textDecoration: 'none' }}>
              nobrandstore3@gmail.com
            </a>
          </div>

          <div style={{ background: 'var(--white)', borderRadius: 10, padding: 16, border: '0.5px solid var(--card-border)' }}>
            <div style={{ fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--blue)', marginBottom: 8, fontWeight: 500 }}>WhatsApp</div>
            <a href="https://wa.me/919363012496" style={{ fontSize: 14, color: 'var(--navy)', textDecoration: 'none' }}>
              +91 93630 12496
            </a>
          </div>

          <div style={{ background: 'var(--white)', borderRadius: 10, padding: 16, border: '0.5px solid var(--card-border)' }}>
            <div style={{ fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--blue)', marginBottom: 8, fontWeight: 500 }}>Location</div>
            <div style={{ fontSize: 14, color: '#444' }}>Chennai, Tamil Nadu, India</div>
          </div>

          <div style={{ background: 'var(--white)', borderRadius: 10, padding: 16, border: '0.5px solid var(--card-border)' }}>
            <div style={{ fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--blue)', marginBottom: 8, fontWeight: 500 }}>Support Hours</div>
            <div style={{ fontSize: 14, color: '#444' }}>Monday – Saturday, 10am – 7pm IST</div>
          </div>
        </div>
      </div>
      <BottomNav />
    </div>
  );
}